export default "__VITE_ASSET__CmPPLk72__"